import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import RenderTextfieldHeader from 'pages/renderTextFieldHeader';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';



const columnTypes = {
  productLine: { type: 'text', name: 'productLine', matchFields: ['productLine'] },
  tabCategory: { type: 'text', name: 'tabCategory', matchFields: ['tabCategory'] },
  subSectionId: { type: 'text', name: 'subSectionId', matchFields: ['subSectionId'] },
  verticalStepperHeader: { type: 'text', name: 'verticalStepperHeader', matchFields: ['verticalStepperHeader'] },
  choiceId: { type: 'text', name: 'choiceId', matchFields: ['choiceId'] },
  choiceName: { type: 'text', name: 'choiceName', matchFields: ['choiceName'] },
  sequence: { type: 'text', name: 'sequence', matchFields: ['sequence'] },
  author: { type: 'text', name: 'author', matchFields: ['lastModBy', 'lastModifiedDate'] },
};

const ellipsisSx = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  display: 'block'
};

const renderEllipsisCell = (value) => (
  <Tooltip title={value || ''}>
    <Typography variant='subtitle2' sx={ellipsisSx}>
      {value}
    </Typography>
  </Tooltip>
);

const OCUISpecColumns = ({ filters, handleChange, handleEdit }) => {
    return [
          {
            headerName: 'Product Line',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'productLine',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.productLine),
            renderHeader: () => (<RenderTextfieldHeader colData={columnTypes.productLine} label="Product Line" filters={filters} handleChange={handleChange} />),
          },
          {
            headerName: 'Tab Category',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'tabCategory',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.tabCategory),
            renderHeader: () => (<RenderTextfieldHeader colData={columnTypes.tabCategory} label="Tab Category" filters={filters} handleChange={handleChange} />),
          },
          {
            headerName: 'Sub Section ID',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'subSectionId',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.subSectionId),
            renderHeader: () => (
              <RenderTextfieldHeader
                colData={columnTypes.subSectionId}
                label="Sub Section ID"
                filters={filters}
                handleChange={handleChange}
              />
            ),
          },
            {
            headerName: 'Vertical Stepper Header',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'verticalStepperHeader',
            flex: 0.6,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.verticalStepperHeader),
            renderHeader: () => (<RenderTextfieldHeader colData={columnTypes.verticalStepperHeader} label="Vertical Stepper Header" filters={filters} handleChange={handleChange} />),
            },
            {
            headerName: 'Choice ID',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'choiceId',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.choiceId),
            renderHeader: () => (
              <RenderTextfieldHeader
                colData={columnTypes.choiceId}
                label="Choice ID"
                filters={filters}
                handleChange={handleChange}
              />
            ),
            },
            {
            headerName: 'Choice Name',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'choiceName',
            flex: 0.7,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.choiceName),
            renderHeader: () => (<RenderTextfieldHeader colData={columnTypes.choiceName} label="Choice Name" filters={filters} handleChange={handleChange} />),
            },
            {
            headerName: 'Sequence',
            headerClassName: 'dashboard-data-grid-headers',
            field: 'sequence',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => renderEllipsisCell(params.row.sequence),
            renderHeader: () => (<RenderTextfieldHeader colData={columnTypes.sequence} label="Sequence" filters={filters} handleChange={handleChange} />),
          },
          {
              headerName: 'Author',
              field: 'author',
              headerClassName: 'dashboard-data-grid-headers',
              flex: 0.9,
              sortable: false,
              renderCell: (params) => {
                const dateValid = moment(params.row.lastModifiedDate).isValid();
                const dateStr = dateValid ? moment(params.row.lastModifiedDate).utc().format('LLLL') : '';
                const fromNowStr = dateValid ? moment(params.row.lastModifiedDate).utc().fromNow() : '';
                return (
                  <Tooltip title={`${params.row.lastModBy || ''}${dateValid ? ` | ${dateStr} - ${fromNowStr}` : ''}`}>
                    <div className='effective-date-data' style={{ width: '100%' }}>
                      <Typography variant='subtitle2' sx={ellipsisSx}>
                        {params.row.lastModBy}
                      </Typography>
                      {dateValid &&
                        <Typography
                          className='file-name effective-date-data'
                          sx={{ ...ellipsisSx, fontSize: "12px" }}
                        >
                          {dateStr}{' - '}{fromNowStr}
                        </Typography>
                      }
                    </div>
                  </Tooltip>
                );
              },
              renderHeader: () => (
                <RenderTextfieldHeader
                  colData={columnTypes.author}
                  label="Author"
                  filters={filters}
                  handleChange={handleChange}
                />
              ),
            },
            {
              headerName: '',
              field: 'actions',
              headerClassName: 'dashboard-data-grid-headers',
              flex: 0.5,
              sortable: false,
              renderCell: (params) => (
                  <Tooltip title="Edit">
                      <IconButton color="primary" onClick={() => handleEdit(params.row)} size="small">
                          <DriveFileRenameOutlineIcon fontSize="small" />
                      </IconButton>
                  </Tooltip>
              ),
           }
    ];
};

export default OCUISpecColumns;